// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__gL7ur","footer":"Form_footer__2zUS3"};